/**
 * Constants for calibration ratings and configurations
 */

export const RATING_OPTIONS = [
   { label: 'A+', value: 'A+' },
   { label: 'A', value: 'A' },
   { label: 'B+', value: 'B+' },
   { label: 'B', value: 'B' },
   { label: 'C', value: 'C' },
   { label: 'D', value: 'D' }
];

export const RATING_OPTIONS_WITH_EMPTY = [
   { label: '-', value: '' },
   ...RATING_OPTIONS
];

export const CUSTOM_RATING_ORDER = {
   'A+': 6,
   'A': 5,
   'B+': 4,
   'B': 3,
   'C': 2,
   'D': 1,
   '': 0
};

export const SCORE_CHANGE_OPTIONS = [
   { label: 'All', value: 'all' },
   { label: 'CHANGED', value: 'changed' },
   { label: 'UNCHANGED', value: 'unchanged' },
   { label: '+1 Rating', value: 1 },
   { label: '+2 Rating', value: 2 },
   { label: '-1 Rating', value: -1 },
   { label: '-2 Rating', value: -2 }
];

export const TABLE_COLUMNS = [
   'Employee',
   'Grade',
   'Supervisor',
   'Prev. Rating',
   'Actual',
   'Calibration (Previous)',
   'Calibration',
   'Status',
   'Justification'
];

export const COLUMN_OPTIONS = [
   { label: 'All', value: 'all' },
   ...TABLE_COLUMNS.map(col => ({ label: col, value: col }))
];

export const SORT_STATES = {
   DEFAULT: 'default',
   ASCENDING: 'ascending',
   DESCENDING: 'descending'
};

export const JUSTIFICATION_TYPES = {
   TOP: 'top',
   BOTTOM: 'bottom',
   DEFAULT: 'default'
};

export const HIGHLIGHT_COLORS = {
   MISSING_JUSTIFICATION: '#ffe6e6',
   TOP_USER: '#FEFFE6',
   DEFAULT: 'transparent'
};
